<p-blockUI [blocked]="pageLoading()" />
<app-progress-spinner [enabled]="pageLoading()" />

@let note = controllerNote();
@let _category = category();

<main>
  <form [formGroup]="noteFormGroup">
    <section formGroupName="typeAOR">
      <div>
        <label for="category">Category: </label>
        {{ note.category }}
      </div>
      <div>
        <label for="noteType">Note Type: </label>
        {{ note.noteType }}
      </div>
      <div>
        <label for="createdAt">Created At: </label>
        {{ note.createdAt | date: 'MM/dd/yyyy HH:mm:ss' }}
      </div>
      <div>
        <label for="aor">AOR: </label>
        {{ note.AORName }}
      </div>
      <fieldset>
        <div>
          <p-checkbox
            class="col-sm-2"
            formControlName="maop"
            value="MAOP"
            [binary]="true"
          />
          <label>{{ 'CRM.LABEL.MAOP' | translate }}</label>
        </div>
        <div>
          <p-checkbox
            class="col-sm-2"
            formControlName="falseAlarm"
            value="False Alarm"
            [binary]="true"
          />
          <label>{{ 'CRM.LABEL.FALSE_ALARM' | translate }}</label>
        </div>
        <div>
          <p-checkbox
            class="col-sm-2"
            formControlName="abnormalOperation"
            value="Abnormal Operation"
            [binary]="true"
          />
          <label>{{ 'CRM.LABEL.ABNORMAL_OP' | translate }}</label>
        </div>
        <div>
          <p-checkbox
            class="col-sm-2"
            formControlName="includeInTurnover"
            value="Include in Turnover"
            [binary]="true"
          />
          <label>{{ 'CRM.LABEL.INC_IN_TURNOVER' | translate }}</label>
        </div>
        <div>
          <p-checkbox
            class="col-sm-2"
            formControlName="calloutInitiated"
            value="Callout Initiated"
            [binary]="true"
          />
          <label>{{ 'CRM.LABEL.CALLOUT_INIT' | translate }}</label>
        </div>
        <div>
          <p-checkbox
            class="col-sm-2"
            formControlName="maintenance"
            value="Maintenance"
            [binary]="true"
          />
          <label>{{ 'CRM.LABEL.MAINTENANCE' | translate }}</label>
        </div>
      </fieldset>
    </section>
    <p-divider />
    <section>
      <header>
        <h3>Facility / Contacts / Location Info</h3>
      </header>
      <div>
        <label for="contact">Contact: </label>
        {{ note.contactName }}
      </div>
      @if (_category === 'System') {
        <div>
          <label for="systemName">System Name: </label>
          {{ note.system }}
        </div>
      }
      @if (_category !== 'Pipeline' && _category !== 'System') {
        <div>
          <label for="facility">Facility: </label>
          {{ note.facilityName }}
        </div>
        <div>
          <label for="facilityId">Facility ID: </label>
          {{ note.facilityUID }}
        </div>
        <div>
          <label for="scadaId">SCADA ID:</label>
          {{ note.facilityScadaId }}
        </div>
      }
      @if (_category === 'Valve') {
        <div>
          <label for="valvePosition">Position: </label>
          {{ note.valvePosition }}
        </div>
      }
      @if (_category === 'External Caller') {
        <div>
          <label for="state">State:</label>
          {{ note.state }}
        </div>
        <div>
          <label for="county">County: </label>
          {{ note.county }}
        </div>
        <div>
          <label for="township">Township: </label>
          {{ note.township }}
        </div>
        <div>
          <label for="contactPhone">Contact Phone Number: </label>
          {{ note.phoneNumber }}
        </div>
        <div>
          <label for="firstName">Caller First Name: </label>
          {{ note.callerFirstName }}
        </div>
        <div>
          <label for="lastName">Caller Last Name: </label>
          {{ note.callerLastName }}
        </div>
      }
      @if (_category === 'Pipeline' || _category === 'External Caller') {
        <div>
          <label for="pipelineNum">Pipeline: </label>
          {{ note.pipeline }}
        </div>
        <div>
          <label for="pipelineSection">Pipeline Section: </label>
          {{ note.pipelineSection }}
        </div>
      }
      @if (_category === 'Compressor Station') {
        <div>
          <label for="unit">Unit: </label>
          {{ note.unit }}
        </div>
        <div>
          <label for="unitStatus">Unit Status: </label>
          {{ note.unitStatus?.name }}
        </div>
        <div>
          <label for="SCADAControl">Scada Control: </label>
          {{ note.SCADAControl }}
        </div>
      }
    </section>
  </form>
  <p-divider />
  <section>
    <header>
      <h3>Note Entries</h3>
    </header>
    @for (entry of note.entries; track entry.id; let i = $index) {
      @if (i !== 0) {
        <p-divider />
      }
      <app-log-entry [entry]="entry" #noteEntry />
    } @empty {
      No note entries to show.
    }
  </section>
</main>
